import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../../common/u1/cn";

/* What TREVEX is, and what to do next — one card, two halves. */
export const StatusCard = ({ hasCompany = true, className = "" }) => (
  <section
    className={cn(
      "overflow-hidden rounded-[18px] border border-[var(--line)] bg-white shadow-[0_1px_2px_rgba(20,40,60,.03)]",
      className
    )}
  >
    <p className="border-b border-[var(--line)] bg-[var(--field-inset)] px-6 py-[18px] text-[13.5px] leading-[1.6] text-[var(--ink-2)] font-sans">
      <b className="font-bold text-[var(--ink)]">
        TREVEX is the commercial directory for every UAE business, and for every
        business anywhere that wants to trade with the UAE.
      </b>{" "}
      Get found by the companies looking for you, check who you are dealing with
      before you deal with them, and build a profile the market can trust. TREVEX
      also helps you manage trade risk and reach the finance behind your next
      deal. Use the panel on the left — Trade Information, Trade Finance, and
      Trade Risk — to explore everything the platform offers.
    </p>

    <div className="flex flex-col gap-4 px-6 py-[22px] sm:flex-row sm:items-center sm:gap-[18px]">
      <span
        aria-hidden="true"
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[13px] bg-[var(--coral-soft)] text-[var(--coral)]"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6 3h12l3 5-9 12L3 8l3-5z" opacity="0.9" />
        </svg>
      </span>

      <div className="min-w-0 flex-1">
        <h3 className="mb-[5px] text-[17px] font-bold text-[var(--ink)] font-sans">
          {hasCompany
            ? "You are on TREVEX. Now make it work harder."
            : "Claim your business to get started"}
        </h3>
        <p className="m-0 max-w-[620px] text-[13.5px] leading-[1.55] text-[var(--ink-2)] font-sans">
          {hasCompany ? (
            <>
              Your profile is live. Become a Member to earn the Member rate on
              every report, join the Partner Program, and give and receive
              Payment Endorsements that show the market you pay and get paid.
            </>
          ) : (
            <>
              Your business already has a free Listing built from public
              licensing and registry data. Claim it to control what the market
              sees, follow the businesses you trade with, and unlock everything
              TREVEX can do.
            </>
          )}
        </p>
      </div>

      <Link
        to={hasCompany ? "/dashboard/membership" : "/sign-up"}
        state={hasCompany ? undefined : { redirectToStep: 6 }}
        className="inline-flex h-[46px] shrink-0 items-center justify-center whitespace-nowrap rounded-xl sm:ml-auto bg-[var(--coral)] px-[22px] text-[14.5px] font-bold leading-none text-white shadow-[0_10px_22px_-10px_rgba(234,85,57,.7)] transition-colors hover:bg-[var(--orange-hover)]"
      >
        {hasCompany ? "Become a Member" : "Claim your business. It is free."}
      </Link>
    </div>
  </section>
);

export default StatusCard;
